<template>
    <b-modal v-model="showModal" :title="title" size="sm">
        <TrackersSelect
            v-model="trackers"
            multiple
            :trackers-list="actualTrackersList"
        />

        <template #modal-footer>
            <b-button
                :disabled="!trackers.length"
                variant="primary"
                size="lg"
                @click="add"
            >
                Add
            </b-button>
        </template>
    </b-modal>
</template>

<script>

import TrackersSelect from "@/components/manage/TrackersSelect.vue";

export default {
    components: {
        TrackersSelect,
    },

    props: {
        trackersList: {
            type: Array,
            default: null
        },

        excludeTrackersList: {
            type: Array,
            default: () => []
        },

        toFolder: {
            type: Boolean,
            default: false,
        },

        modalId: {
            type: String,
            default: "add-to-trackers-popup",
        },

        header: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            trackers: [],
            showModal: false,
        }
    },

    mounted() {
        this.$store.dispatch('fetchTrackers');
    },

    watch: {
        showModal(val) {
            if (!val) {
                this.$emit('modalClosed');
            }
        }
    },

    computed: {
        title() {
            if (this.header) {
                return this.header;
            }

            if (this.toFolder) {
                return "Add Trackers To Folder";
            }

            return "Add To Trackers";
        },

        actualTrackersList() {
            let trackersList = this.trackersList ?? this.$store.getters.trackersList;

            return trackersList?.filter(tracker => !this.excludeTrackersList.some(existedTracker =>
                typeof existedTracker === 'object'
                    ? parseInt(existedTracker.id) === parseInt(tracker.id)
                    : parseInt(existedTracker) === parseInt(tracker.id))
            )
        }
    },

    methods: {
        open() {
            this.showModal = true;
        },

        add() {
            this.showModal = false;
            this.$bvModal.hide(this.modalId)
            this.$emit('trackersSelected', this.trackers)
            this.trackers = []
        },
    }
}
</script>

<style scoped>
    .popover {
        padding: 10px;
        width: auto;
    }
</style>
